module.exports = __webpack_public_path__ + "static/media/blk-man-think.0ae3c83c.png";